import React from 'react';
import AuthService from 'library/authService/auth-service';
import { Button, Icon } from 'antd';
import settings from 'settings';
import AppLogo from 'library/appLogo';

class SiteTenancy extends React.Component {
  static handleTenancyClick(tenancy) {
    if (tenancy) {
      AuthService.setCurrentTenancy(tenancy);
      AuthService.redirectToHomePage();
    }
  }

  static handleLogoutClick() {
    AuthService.getAuthType();
    AuthService.logout();
  }

  static displayUserDetailError() {
    return (
      <div className="bhp-no-access">
        <div className="bhp-details">
          Sorry. Your user details could not be retrieved
          <br />
          Click below to logout and try again!
        </div>
        <div className="bhp-button-container">
          <Button type="primary" onClick={() => SiteTenancy.handleLogoutClick()}>Logout</Button>
        </div>
      </div>
    );
  }

  static displayTenancyAccessError() {
    return (
      <div className="bhp-no-access">
        <div className="bhp-details">
          Sorry. You do not have any tenancy access
          <br />
          Click below to logout and try again!
        </div>
        <div className="bhp-button-container">
          <Button type="primary" onClick={() => this.handleLogoutClick()}>Logout</Button>
        </div>
      </div>
    );
  }

  static displayTenancySelection(tenancies) {
    return (
      <div className="bhp-site-access">
        <div className="bhp-margin-bottom-4x">Please select your tenancy:</div>
        <div className="bhp-button-container">
          {tenancies.map(tenancy => (
            <Button key={tenancy.tenancyId} type="primary" onClick={() => SiteTenancy.handleTenancyClick(tenancy)}>{tenancy.tenancyName}</Button>
          ))}
        </div>
      </div>
    );
  }

  static displayCheckTenancyAccess() {
    return (
      <div className="bhp-no-access">
        <div className="bhp-details">
          Checking tenancy access...
          <Icon type="loading" />
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      user: null,
      hasAccess: true
    };
  }

  UNSAFE_componentWillMount() {
    this.checkUser();
  }

  checkUser() {
    if (!AuthService.isAuthenticated()) {
      // -- User is not authenticated
      // -- Redirect to login page
      // ---
      AuthService.redirectToLogin();
    }
    else {
      // -- Check if the user has been loaded
      // ---
      const user = AuthService.whoami();
      if (user) {
        // -- User is loaded, check the user's tenancy access
        // ---
        this.checkTenancyAccess(user);
      }
      else {
        // -- User is not loaded. Load the user details,
        // -- tenancy access and permissions.
        // ---
        AuthService.getUser()
          .then((response) => {
            // -- User data retrieved.
            // -- Check the user's tenancy access
            // ---
            this.checkTenancyAccess(response);
          },
          () => {
            // -- Something went wrong. Prompt user to login again
            // -- to see if a token refresh will work
            // ---
            this.setState({ hasAccess: false });
          });
      }
    }
  }

  checkTenancyAccess(user) {
    if (user.tenancies.length === 1) {
      // -- Single tenancy detected. Check if this is
      // -- the current tenancy and redirect to homepage.
      // ---
      if (!user.currentTenancy) {
        AuthService.setCurrentTenancy(user.tenancies[0]);
      }
      AuthService.redirectToHomePage();
    }
    else if (user.tenancies.length > 1) {
      if (user.currentTenancy) {
        // -- User has selected a tenancy.
        // -- Redirect to homepage.
        // ---
        AuthService.redirectToHomePage();
      }
      else {
        // -- Display Tenancy selection
        // ---
        this.setState({
          user,
          hasAccess: true
        });
      }
    }
    else {
      // -- No tenancies available to show
      // ---
      this.setState({
        user,
        hasAccess: false
      });
    }
  }

  renderOptions() {
    const { user, hasAccess } = this.state;
    if (user) {
      return (hasAccess ? SiteTenancy.displayTenancySelection(user.tenancies) : SiteTenancy.displayTenancyAccessError());
    }
    return (hasAccess ? SiteTenancy.displayCheckTenancyAccess() : SiteTenancy.displayUserDetailError());
  }

  render() {
    return (
      <div className="bhp-tenancy">
        <div className="bhp-modal bhp-open">
          <div className="bhp-modal-panel">
            <div className="bhp-tenancy-panel">
              <div className="bhp-header">
                <AppLogo />
              </div>
              <div className="bhp-content">
                <div className="bhp-title-2 bhp-margin-bottom-1x">Crew Rostering</div>
                {this.renderOptions()}
              </div>
            </div>
          </div>
        </div>
        <div className="bhp-footer">
          Crew Rostering v{settings.APP_CONFIG.versionNo} &copy; BHP
        </div>
      </div>
    );
  }
}

export default SiteTenancy;
